<ng-template #btnTemplate let-item>
  <button class="no-underline link-hover flex flex--row" (click)="emitClick(item.data)">
    {{ item.options.btnText }} <fcom-icon class="ps-xsmall-l" [name]="item.options.btnIcon" />
  </button>
</ng-template>
<table class="table fill relative white-bg surface-primary">
  <caption class="is-vishidden">
    {{
      caption()
    }}
  </caption>
  @if (headers()?.length > 0 && !!headerTemplate()) {
    <thead [ngClass]="{ 'dn-mobile': mobileTemplate() || mobileHeader() }">
      <tr>
        @for (header of headers() ?? []; track header.key; let index = $index) {
          <th
            class="align-left ps-medium-y ps-xsmall-x border-bottom border-top nordic-blue-100-border border-primary"
            scope="col"
            [class.border-left]="index === 0"
            [class.border-right]="index === headers().length - 1"
            [class.rounded-top-left-large]="index === 0"
            [class.rounded-top-right-large]="index === headers().length - 1"
            [ngClass]="header?.options?.class"
            #tableHeader
          >
            <ng-container *ngTemplateOutlet="headerTemplate(); context: { $implicit: header }" />
          </th>
        }
      </tr>
    </thead>
  }
  @if (mobileHeader()) {
    <thead class="dn-tablet-up">
      <tr>
        <th
          class="ps-medium-y ps-xsmall-x border-left border-top border-right nordic-blue-100-border border-primary rounded-top-large"
          scope="col"
        >
          <ng-container *ngTemplateOutlet="mobileHeader()" />
        </th>
      </tr>
    </thead>
  }
  <tbody [ngClass]="{ 'dn-mobile': mobileTemplate() }">
    @for (row of tableData() ?? []; track $index; let rowIndex = $index) {
      <tr [ngClass]="{ 'action-row': !!row.rowAction }" (click)="row.rowAction && emitClick(row.rowAction.data)">
        @for (header of headers() ?? []; track header.key; let columnIndex = $index) {
          <td
            class="border-bottom nordic-blue-100-border border-primary"
            [class.ps-small-y]="!row[header.key]?.options?.ignorePadding"
            [class.ps-xsmall-x]="!row[header.key]?.options?.ignorePadding"
            [class.border-left]="columnIndex === 0"
            [class.border-right]="columnIndex === headers().length - 1"
            [class.border-top]="rowIndex === 0 && !headerTemplate()"
            [class.rounded-top-left-large]="rowIndex === 0 && columnIndex === 0 && !headerTemplate()"
            [class.rounded-top-right-large]="
              rowIndex === 0 && columnIndex === headers().length - 1 && !headerTemplate()
            "
            [class.rounded-bottom-left-large]="
              rowIndex === tableData()?.length - 1 && columnIndex === 0 && !usePagination()
            "
            [class.rounded-bottom-right-large]="
              rowIndex === tableData()?.length - 1 && columnIndex === headers().length - 1 && !usePagination()
            "
            [ngClass]="row[header.key]?.options?.class"
          >
            @if (!row[header.key]?.options?.useBtn) {
              <ng-container *ngTemplateOutlet="cellTemplate(); context: { $implicit: row[header.key].data }" />
            }
            @if (row[header.key]?.options?.useBtn) {
              <ng-container
                *ngTemplateOutlet="
                  btnTemplate;
                  context: {
                    $implicit: {
                      data: row[header.key].data,
                      options: row[header.key]?.options,
                    },
                  }
                "
              />
            }
          </td>
        }
      </tr>
    }
  </tbody>
  @if (mobileTemplate()) {
    <tbody class="dn-tablet-up">
      @for (row of tableData() ?? []; track $index; let rowIndex = $index) {
        <tr [ngClass]="{ 'action-row': !!row.rowAction }" (click)="row.rowAction && emitClick(row.rowAction.data)">
          <td
            class="border-left border-right border-bottom nordic-blue-100-border border-primary ps-small-y ps-xsmall-x"
            [class.border-top]="rowIndex === 0"
            [class.rounded-large]="tableData()?.length === 1 && !mobileHeader()"
            [class.rounded-top-large]="rowIndex === 0 && !mobileHeader() && tableData()?.length > 1"
            [class.rounded-bottom-large]="
              rowIndex === tableData()?.length - 1 && !usePagination() && tableData()?.length > 1
            "
          >
            <ng-container *ngTemplateOutlet="mobileTemplate(); context: { $implicit: row }" />
          </td>
        </tr>
      }
    </tbody>
  }
  @if (loading()) {
    <tbody class="absolute fill grow block top-left">
      <tr class="absolute fill grow">
        <td class="absolute fill grow loader">
          <div
            class="grey-25-bg bg-primary border fill grow rounded-large flex flex--center"
            data-testid="table-loader"
          >
            <fcom-loader [loaderType]="LoaderTheme.INLINE" />
          </div>
        </td>
      </tr>
    </tbody>
  }
  @if (!loading() && !tableData()?.length && noResultsMsg()) {
    <tbody class="no-results">
      <tr>
        <td
          [colSpan]="headers()?.length || 1"
          class="grey-25-bg bg-primary align-center border-left border-bottom border-right rounded-bottom-large pr-large-y ps-large-x"
        >
          <span class="font-body-1 medium-type inline-block font-label-medium" data-testid="table-no-results">{{
            noResultsMsg()
          }}</span>
        </td>
      </tr>
    </tbody>
  }
</table>
@if (usePagination()) {
  <fcom-pagination
    [totalItems]="totalPaginationItems()"
    [textBeforePages]="textBeforePages()"
    (indexesChange)="changeIndexes($event)"
    [itemsPerPageOptions]="itemsPerPageOptions()"
  />
}
